<app-menu>
  <div class="dashboard-container">
    <h1><i class="fas fa-chart-line"></i> Shipper and Consignee Dashboard</h1>
    <div *ngIf="loading" class="loading">Loading...</div>
    <div *ngIf="!loading && errorMessage" class="error">{{ errorMessage }}</div>

    <div class="data-sections">
      <div class="data-section">
        <h3><i class="fas fa-database"></i> Dashboard Data</h3>
        <div class="dropdown-container">
          <div class="dropdown-group">
            <label class="label" for="shipperRegion">Shipper Region:</label>
            <select class="select" id="shipperRegion" [(ngModel)]="selectedShipperRegion" (change)="onRegionChange()">
              <option *ngFor="let region of shipperRegions" [value]="region">{{ region }}</option>
            </select>
          </div>
          <div class="dropdown-group">
            <label class="label" for="consigneeRegion">Consignee Region:</label>
            <select class="select" id="consigneeRegion" [(ngModel)]="selectedConsigneeRegion" (change)="onRegionChange()">
              <option *ngFor="let region of consigneeRegions" [value]="region">{{ region }}</option>
            </select>
          </div>
        </div>
        <div *ngIf="instanceCount !== null" class="instance-count">
          Instance Count: {{ instanceCount }}
        </div>
        <div style="width: 100%; height: 400px;">
          <canvas id="instanceCountChart"></canvas>
        </div>
      </div>
      <div class="data-section">
        <h3><i class="fas fa-users"></i> Top Five Customers per Region</h3>
        <div class="dropdown-container">
          <div class="dropdown-group">
            <label class="label" for="customerSelect">Select Customer:</label>
            <select class="select" id="customerSelect" [(ngModel)]="selectedCustomer" (change)="onCustomerChange()">
              <option value="" disabled selected>Select a customer</option>
              <option *ngFor="let customer of uniqueCustomers" [value]="customer">{{ customer }}</option>
            </select>
          </div>
          <div class="dropdown-group">
            <label class="label" for="shipperSelect">Select Shipper:</label>
            <select class="select" id="shipperSelect" [(ngModel)]="selectedShipper" (change)="onShipperChange()">
              <option value="" disabled selected>Select a shipper</option>
              <option *ngFor="let shipper of selectedCustomerShippers" [value]="shipper">{{ shipper }}</option>
            </select>
          </div>
        </div>
        <div *ngIf="selectedShipper" class="customer-data" style="margin-top: 20px;">
          <h4>Selected Customer's Data</h4>
          <div style="width: 100%; height: 400px;">
            <canvas id="customerChart"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="data-section full-width">
      <h3><i class="fas fa-table"></i> Expedited and High Priority Counts</h3>
      <ag-grid-angular class="ag-theme-alpine" 
        style="width: 100%; height: 500px;" 
        [rowData]="rowData"
        [columnDefs]="columnDefs" 
        rowSelection="single" 
        [pagination]="true" 
        [paginationPageSize]="10">
      </ag-grid-angular>
    </div>
    <div class="data-section full-width">
      <h3><i class="fas fa-calendar-alt"></i> Missed Appointment Timeline</h3>
      <div class="dropdown-container">
        <div class="dropdown-group">
          <label class="label" for="timelineCustomerSelect">Customer Name:</label>
          <select class="select" id="timelineCustomerSelect" [(ngModel)]="selectedTimelineCustomer" (change)="onTimelineFilterChange()">
            <option value="" disabled selected>Select a customer</option>
            <option *ngFor="let customer of uniqueTimelineCustomers" [value]="customer">{{ customer }}</option>
          </select>
        </div>
        <div class="dropdown-group">
          <label class="label" for="timelineAppointmentStart">Appointment Start Date:</label>
          <input class="select" type="date" id="timelineAppointmentStart" [(ngModel)]="selectedTimelineDate" (change)="onTimelineFilterChange()">
        </div>
      </div>
      <div class="card-container" *ngIf="selectedTimelineCustomer">
        <div class="card" *ngFor="let appointment of filteredAppointments">
          <div class="timeline-card">
            <div class="timeline-card-header">
              <!-- <div class="timeline-dot"></div> -->
              <!-- <div class="title">{{ appointment.customer_name }}</div> -->
              <div class="date text-bold">{{ appointment.appointment_start | date: 'short' }}</div>
            </div>
            <div class="timeline-card-body">
              <!-- <div class="alternate-reference">Reference: {{ appointment.alternate_reference }}</div> -->
              <div class="status" [ngClass]="{ 'early': appointment.departure_status === 'Early Departure', 'late': appointment.departure_status !== 'Early Departure' }">
                {{ appointment.departure_status }}
              </div>
              <div class="carrier">Carrier: {{ appointment.carrier_name }}</div>
              <div class="additional-info">
                <!-- <div>Appointment End: {{ appointment.appointment_end | date: 'short' }}</div> -->
                <div>Load Start: {{ appointment.load_start | date: 'short' }}</div>
                <!-- <div>Load End: {{ appointment.load_end | date: 'short' }}</div> -->
                <div>Arrival Status: {{ appointment.arrival_status }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-menu>
